import { Button, ListGroup } from '@readcloud/component-library';
import { IButtonProps } from '@readcloud/component-library';

import { scaleModes } from '@readcloud/data';
import {
  Tooltip,
  TooltipProvider,
  TooltipContent,
  TooltipTrigger,
} from '@readcloud/ui';
import C from 'classnames';
import React, { ForwardedRef, RefObject, forwardRef } from 'react';
import { MdZoomIn, MdZoomOut } from 'react-icons/md';
import { LoadingSection } from '../../Common/Base/LoadingSection';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@readcloud/ui';

const ZoomOutButton = forwardRef(
  (
    props: JSX.IntrinsicAttributes &
      IButtonProps &
      React.RefAttributes<HTMLButtonElement>,
    ref: ForwardedRef<HTMLButtonElement>
  ) => (
    <>
      <Button variant="light" {...props} ref={ref}>
        <MdZoomOut size="28" />
      </Button>
    </>
  )
);
const ZoomInButton = forwardRef(
  (
    props: JSX.IntrinsicAttributes &
      IButtonProps &
      React.RefAttributes<HTMLButtonElement>,
    ref: ForwardedRef<HTMLButtonElement>
  ) => (
    <Button variant="light" {...props} ref={ref}>
      <MdZoomIn size="28" />
    </Button>
  )
);

const ScaleSelect: React.ComponentType<{
  value: number;
  fitWidthValue: number;
  onChange?: (value: number) => void;
}> = ({ value, fitWidthValue, onChange }) => {
  return (
    <Select
      value={value.toString()}
      onValueChange={(newValue) => onChange?.(Number(newValue))}
    >
      <SelectTrigger>
        <SelectValue>{(value * 100).toFixed(0)}%</SelectValue>
      </SelectTrigger>
      <SelectContent className="rc-z-[2000]">
        <SelectItem value={String(fitWidthValue)}>Fit Width</SelectItem>
        {Object.entries(scaleModes).map(([label, scale]) => (
          <SelectItem key={label} value={String(scale)}>
            {(scale * 100).toFixed()}%
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export const PageScalerComponent: React.FC<{
  onIncrease?: () => void;
  onDecrease?: () => void;
  value: number;
  outerWidth: number;
  initialPageWidth: number;
  onChange?: (v: number) => void;
  loading?: boolean;
}> = ({
  onIncrease,
  onDecrease,
  value,
  onChange,
  initialPageWidth,
  outerWidth,
  loading,
}) => {
  return loading ? (
    <>
      <LoadingSection height="43px" width="150px" />
    </>
  ) : (
    <>
      <div className="rc-flex rc-items-center">
        {onDecrease ? (
          <React.Fragment>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <ZoomOutButton
                    onClick={() => {
                      onDecrease();
                    }}
                  />
                </TooltipTrigger>
                <TooltipContent>Zoom Out</TooltipContent>
              </Tooltip>
            </TooltipProvider>
            <div className="rc-p-1" />
          </React.Fragment>
        ) : null}
        <ScaleSelect
          value={value}
          onChange={onChange}
          fitWidthValue={outerWidth / initialPageWidth || 1}
        />
        {onIncrease ? (
          <React.Fragment>
            <div className="rc-p-1" />
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <ZoomInButton
                    onClick={() => {
                      onIncrease();
                    }}
                  />
                </TooltipTrigger>
                <TooltipContent>Zoom In</TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </React.Fragment>
        ) : null}
      </div>
    </>
  );
};
